import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { salesChannel_desk_Id, device_desk_Id } from '../config'
import authentication from './authentication'

Vue.use(Vuex)

export function createStore() {
  return new Vuex.Store({
    modules:{
      auth:authentication
     },
    state: {
      layout: 'flight-result-layout',
      locale: null,
      currentLanguage: 'ar',
      currentPage: 'Home',
      selectedCurrency: 'SAR',
      selectedCurrencyName: 'SAR Saudi Riyal',
      domain: {
        cur: 'SAR',
        sales_channel : salesChannel_desk_Id,
        device_Id: device_desk_Id,
      },
      containerClass: '',
      lists: {},
      air: {
        searchRS: {},
        reviewRS: {},
        pnrRS: {},
        ticketRS: {},
        searchRQ: {},
        priceRS: {}
      },
      travellers: [],
      modify: false
    },
    actions,
    mutations,
    getters
  })
}



// WEBPACK FOOTER //
// src/store/index.js